import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Project } from '@/types';

interface UserRoleInfo {
  isEmployee: boolean;
  isManager: boolean;
  isAdmin: boolean;
  hasManagerProjects: boolean;
  shouldShowManagerSection: boolean;
  shouldShowAdminSection: boolean;
  shouldShowSingleLayer: boolean;
}

export const useUserRole = (managedProjects: Project[] = []): UserRoleInfo => {
  const { user } = useAuth();

  return useMemo(() => {
    if (!user) {
      return {
        isEmployee: false,
        isManager: false,
        isAdmin: false,
        hasManagerProjects: false,
        shouldShowManagerSection: false,
        shouldShowAdminSection: false,
        shouldShowSingleLayer: true,
      };
    }

    const isAdmin = user.role === 'admin';
    const isManager = user.role === 'manager';
    const isEmployee = ['employee', 'contractor', 'intern', 'other'].includes(user.role);
    const hasManagerProjects = managedProjects.length > 0;

    // 布局控制逻辑
    const shouldShowAdminSection = isAdmin;
    const shouldShowManagerSection = (isManager || hasManagerProjects) && !isAdmin;
    const shouldShowSingleLayer = isEmployee && !hasManagerProjects && !isAdmin;

    return {
      isEmployee,
      isManager,
      isAdmin,
      hasManagerProjects,
      shouldShowManagerSection,
      shouldShowAdminSection,
      shouldShowSingleLayer,
    };
  }, [user, managedProjects]);
};